import I18n from 'shared/helpers/i18n_with_reporting'
import json from '../../../config/locales/javascript.de.json'
I18n.locale = 'de'
I18n.translations = { de: json }
global.I18n = I18n
